import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../../lib/api";

// Hook con la lógica de generación de contenido (texto, imágenes, video) de una campaña
export const useCampaignContent = (gc) => {
  const [textContent, setTextContent] = useState(null);
  const [loadingText, setLoadingText] = useState(false);
  const [imagePrompt, setImagePrompt] = useState("");
  const [images, setImages] = useState([]);
  const [loadingImage, setLoadingImage] = useState(false);
  const [videos, setVideos] = useState([]);
  const [loadingVideo, setLoadingVideo] = useState(false);

  const genText = async () => {
    setLoadingText(true);
    try {
      const { data } = await api.post(`/guided/campaigns/${gc.gc_id}/text`, {});
      setTextContent(data);
      toast.success("Texto generado");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoadingText(false); }
  };

  const genImage = async () => {
    setLoadingImage(true);
    try {
      const { data } = await api.post(`/guided/campaigns/${gc.gc_id}/image`, { prompt: imagePrompt });
      setImages((p) => [...p, data]);
      toast.success("Imagen generada con tu leyenda");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoadingImage(false); }
  };

  const addImageFrom = async (endpoint, body) => {
    if (images.length >= 3) return toast.error("Cada campaña permite máximo 3 imágenes.");
    try {
      const { data } = await api.post(`/guided/campaigns/${gc.gc_id}/${endpoint}`, body);
      setImages((p) => [...p, data]);
      toast.success("Imagen agregada con marca de agua");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  const addPageImage = (imageUrl) => addImageFrom("image-from-url", { image_url: imageUrl });
  const addUploadedImage = (fileId) => addImageFrom("image-from-upload", { file_id: fileId });

  const pollVideo = (id, tries = 0) => {
    if (tries > 60) { setLoadingVideo(false); return; }
    api.get(`/content/${id}`).then((r) => {
      if (r.data.status === "done") {
        setVideos((p) => p.map((v) => (v.content_id === id ? r.data : v)));
        setLoadingVideo(false);
        toast.success("¡Video listo!");
        return;
      }
      if (r.data.status === "error") {
        setVideos((p) => p.map((v) => (v.content_id === id ? r.data : v)));
        setLoadingVideo(false);
        toast.error(r.data.error || "No se pudo generar el video");
        return;
      }
      setTimeout(() => pollVideo(id, tries + 1), 5000);
    }).catch((err) => {
      console.debug("video poll error:", err);
      setTimeout(() => pollVideo(id, tries + 1), 5000);
    });
  };

  const genVideo = async () => {
    setLoadingVideo(true);
    try {
      const { data } = await api.post(`/guided/campaigns/${gc.gc_id}/video`, { prompt: imagePrompt });
      setVideos((p) => [...p, { ...data }]);
      pollVideo(data.content_id);
    } catch (err) { setLoadingVideo(false); toast.error(apiError(err.response?.data?.detail)); }
  };

  return {
    textContent, loadingText, genText,
    imagePrompt, setImagePrompt, images, loadingImage, genImage,
    addPageImage, addUploadedImage, videos, setVideos, loadingVideo, genVideo,
  };
};
